/*
 * @Author: 丨小小风离丨
 * @Date: 2024-04-25 20:02:15
 * @LastEditTime: 2025-07-10 11:10:03
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\page\intentRegistration\index.tsx
 * @Description: 
 */
import { CommmonGet, CommmonPost } from '@/util/network/api';
import { baseURL } from '@/util/network/axios';
import { CheckEmail, CheckIdCard, CheckPhone, beforeuploadImage, keyPureMath, replyCN, replyNum, trimFormValues, uploadparams } from '@/util/public';
import { imageToDataUrl } from '@/util/util';
import { Col, Form, Row, Select, Spin, Upload, message } from 'antd';
import { AwesomeQR } from 'awesome-qr';
import { LgButton, LgDatePicker, LgInput, LgRadio } from 'lancoo-web-ui';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectSchoolId, selectSchoolInfo, selectSchoolLevel } from '../../store/reducers/schoolInfo';
import { selectUserId } from '../../store/reducers/userInfo';
import { defaultBasicOrdere, generateOrderedArray } from '../enrollPlan/common/publicFunc';
import SourceAddre from '../enrollPlan/list/SelectAddress/sourceAddre';
import ExtraItem from '../enrollPlan/list/extraItem';
import NumericInput from '../enrollPlan/list/numericInput';
import './index.scss';
import { extraRefTs } from './type';

function IntentRegistration() {

    const serviceRegistra = {
        getPurposeRegisterTemplate: '/portal/getPurposeRegisterTemplate',
        register: '/portal/purpose/register'
    }

    const schoolInfo = useSelector(selectSchoolInfo);
    const userId = useSelector(selectUserId);
    const schoolId = useSelector(selectSchoolId);
    const schoolLevel = useSelector(selectSchoolLevel); // 获取学校类型

    const [form] = Form.useForm();
    const [extraform] = Form.useForm();

    // 自定义Ref
    const extraRef = useRef<extraRefTs[]>([])
    const [formKey, setFormKey] = useState<number>(0);
    // 刷新
    const [isloading, setIsloading] = useState<boolean>(false);
    // 二维码URL
    const [qrcodeUrl, setqrcodeUrl] = useState<string>("");

    // 显示字段
    const [extramsg, setextramsg] = useState<any>({});
    // 内容信息
    const [editmsg, seteditmsg] = useState<any>({});
    // 模板
    const [templateId, setTemplateId] = useState<any>('');
    // 文件
    const [avatr, setavatr] = useState<any>(null);
    const [, setfile] = useState<any[]>([]);

    // const [majorName, setMajorName] = useState<any>('');
    // 基本信息顺序
    const [basicOrdere, setBasicOrdere] = useState<string[]>(defaultBasicOrdere);
    const [majorList, setMajorList] = useState<any[]>([]);

    const [, forceUpdate] = useState<any>(null);

    // 提交报名信息
    const postData = () => {
        // 去掉两边空格
        trimFormValues(form);
        trimFormValues(extraform);

        form.validateFields().then(value => {

            extraform.validateFields().then(value1 => {
                if (value.firstVolunteer && value.secondVolunteer && value.firstVolunteer === value.secondVolunteer) {
                    message.destroy();
                    message.error('报名志愿不能重复');
                    return;
                } else if (value.firstVolunteer && value.thirdVolunteer && value.firstVolunteer === value.thirdVolunteer) {
                    message.destroy();
                    message.error('报名志愿不能重复');
                    return;
                } else if (value.secondVolunteer && value.thirdVolunteer && value.secondVolunteer === value.thirdVolunteer) {
                    message.destroy();
                    message.error('报名志愿不能重复');
                    return;
                }

                let postdata = [];

                for (let key in extramsg.basicField) {
                    if (extramsg.basicField[key]?.collect) {
                        postdata.push({
                            fieldId: extramsg.basicField[key]?.fieldId,
                            value: getBasicValue(key, value),
                            fillValue: getBasicValue(key, value, 'fillValue')
                        })
                    }
                }
                extramsg?.fields?.map((item: any, index: number) => {
                    // const extravalue = extraform.getFieldValue('extra' + index + 1 + (item.type === 11 ? '11' : ''));
                    const extravalue = extraform.getFieldValue('extra' + index + 1);
                    let selectName = ''
                    let others = null
                    if (item.type == 8) {
                        let index = extravalue.indexOf('other:')
                        console.log(index)
                        if (index != -1) {
                            others = extravalue
                        }
                    }
                    console.log(extravalue)
                    if (item?.optionVOList) {
                        const obj = item?.optionVOList?.find((item1: any) => item1.value == extravalue);
                        selectName = obj?.name || obj?.label || ''
                    }
                    postdata.push({
                        fieldId: item.fieldId,
                        value:
                            (item.type === 1 || item.type === 4 || item.type === 7 || item.type === 10 || item.type === 12) ? extravalue :
                                (item.type === 2 || item.type === 11 || item.type === 8) ? (extravalue === -1 ? "" : extravalue) :
                                    (item.type == 6) ? (extravalue?.length > 0 ? (extravalue?.[0]?.response?.data?.resId || extravalue?.[0]?.uid) : "") : "",
                        fillValue:
                            (item.type === 1 || item.type === 4 || item.type === 7 || item.type === 10 || item.type === 12) ? (selectName || extravalue) :
                                (item.type === 2 || item.type === 11 || item.type === 8) ? (extravalue === -1 ? "" : selectName || extravalue) :
                                    (item.type == 6) ? (extravalue?.length > 0 ? (extravalue?.[0]?.response?.data?.resId || extravalue?.[0]?.uid) : "") : "",
                    })
                })
                setIsloading(true);
                CommmonPost(serviceRegistra.register, {
                    fieldValueList: postdata,
                    userId,
                    schoolId,
                    templateId
                }).then((res: any) => {
                    message.success(res.msg || '登记成功');
                    reset();
                }).catch(error => {
                    error?.msg && message.destroy();
                    error?.msg && message.warning(error?.msg);
                }).finally(() => setIsloading(false))
            }).catch(error => {
                console.log(error);
            })
        }).catch(error => {
            extraform.validateFields();
        })
    }

    const getBasicValue = (key: string, value: any, type?: any): any => {
        let temp = '';
        switch (key) {
            case 'avatar':
                temp = avatr ? avatr.resId : '';
                break;
            default:
                temp = value[key];
                if (type === 'fillValue') {
                    const obj = extramsg?.basicField?.[key]?.options?.find((item: any) => item.value === value[key]);
                    temp = obj?.name || obj?.lable || value[key]
                }
                break;
        }
        return temp
    }

    const getcode = async () => {
        let data = "https://leave.lancooedu.com?sys=T11&type=stranger&school=" + schoolId + "&intentRegistration=true";
        const logoDataUrl = await imageToDataUrl(schoolInfo.SchoolLogos[0].logo)
        const dataUrl = await new AwesomeQR({
            text: data,
            size: 200,
            correctLevel: 3,
            logoImage: logoDataUrl
        }).draw()
        setqrcodeUrl(dataUrl as string)
    }

    useEffect(() => {
        setIsloading(true);
        getcode();
        CommmonGet(serviceRegistra.getPurposeRegisterTemplate).then((res: any) => {
            setextramsg(res?.data || {});
            // 基本信息顺序
            const orderedArray = generateOrderedArray(res?.data?.basicField);
            setBasicOrdere(orderedArray);
            setTemplateId(res?.data?.templateId || '');
        }).catch((err: any) => {
            err?.msg && message.destroy();
            err?.msg && message.error(err?.msg);
        }).finally(() => setIsloading(false))
    }, [])

    useEffect(() => {
        // if (!schoolId || schoolLevel !== 2) {
        //     return
        // }
        CommmonGet('/majorCampus/list', {
            pageIndex: 1,
            pageSize: 1000,
            enableEnroll: -1,
            schoolYear: new Date().getFullYear()
        }).then((res: any) => {
            // const temp = res?.data?.list?.filter(ele => ele.enableEnroll === true)
            const temp = res?.data?.list?.filter(ele => ele.proCode)
            setMajorList(() => temp)
        }).catch((err: any) => {
            setMajorList([])
        })
    }, [])

    const uploaddone = (info: any) => {
        if (info.file.status === 'done') {
            const res = info.file.response
            console.log(res);
            if (res.status !== 0) {
                message.warning(res.msg)
                form.setFieldsValue({ avatar: !avatr ? null : `C:\\fakepath\\${avatr.originalName}` })
            } else {
                // 头像
                let coverobj = {
                    originalName: res.data.originalName,
                    resId: res.data.resId,
                    url: res.data.preUrl
                }
                setavatr(coverobj);
                form.validateFields(['avatar']);
            }
        }
    }

    const getFormColSpan = (item: any, width?: number) => {
        if (width) {
            return width
        }
        let temp = 8
        if (item?.basicField?.avatar?.collect) {
            temp = 12
        }
        return temp
    }

    const getColSpan = (item: any) => {
        let temp = 8
        if (item?.type === 10 || item?.type === 2 || item?.type === 6 || item?.type === 12) {
            temp = 24
        } else {
            temp = 8
        }

        return temp
    }

    const reset = () => {
        setavatr(null);
        form.resetFields();
        extraform.resetFields();

        for (const key in extraRef?.current) {
            extraRef?.current[key]?.reset()
        }
    }

    const handleValuesChange = (changedValues, allValues) => {
        const { trainingStage } = changedValues; // 获取 changedValues 中的 培养层次
        if (trainingStage !== undefined) {
            setFormKey(formKey + 1); // 修改 formKey 的值
        }
    };


    return (
        <div className="intentRegistration">
            <Spin spinning={isloading}>
                <span style={{ display: 'flex', justifyContent: 'center', marginBottom: 20, color: '#ff9900' }}>
                    温馨提示：本次调查登记仅为前期摸底调查，不代表报读我校成功；本次信息由{schoolInfo?.schoolName || '广州市增城区石滩镇绿湖中学'}负责收集且信息严格保密处理。
                </span>
                <div className='content'>
                    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                        <Form
                            form={form}
                            name="basicinfo"
                            labelAlign="right"
                            // labelCol={{ span: 7 }}
                            // wrapperCol={{ span: 17 }}
                            className="intentRegistration_form selfmsg"
                            validateTrigger={['onBlur']}
                            style={{
                                width: extramsg?.basicField?.avatar?.collect ? 'calc(100% - 120px)' : '100%',
                                marginBottom: extramsg?.basicField?.avatar?.collect ? '16px' : 0,
                                minHeight: extramsg?.basicField?.avatar?.collect ? '180px' : 'auto'
                            }}
                            onValuesChange={handleValuesChange}
                        >
                            <Row gutter={24} key={formKey}>
                                {basicOrdere.map((item: any, index: number) => {
                                    let showCont = null
                                    switch (item) {
                                        case 'avatar':
                                            showCont = extramsg?.basicField?.avatar?.collect &&
                                                <Form.Item
                                                    className="avatr"
                                                    name="avatar"
                                                    // initialValue={""}
                                                    wrapperCol={{ span: 23 }}
                                                    rules={[{ required: extramsg?.basicField?.avatar?.need, message: '请上传证件照!' }]}
                                                >
                                                    <div>
                                                        <Upload
                                                            action={baseURL + "/common/uploadFile"}
                                                            headers={{ schoolid: schoolId }}
                                                            maxCount={1}
                                                            data={(file) => uploadparams(file, "image_file")}
                                                            accept="image/*"
                                                            showUploadList={false}
                                                            beforeUpload={beforeuploadImage}
                                                            onChange={file => uploaddone(file)}
                                                        >
                                                            {
                                                                avatr ?
                                                                    // <img style={{ height: "64px", width: "114px", cursor: "pointer",objectFit:"contain" }} src={covermsg.url}></img> :
                                                                    <div
                                                                        className="uploadcover"
                                                                        style={{
                                                                            background: `url(${avatr.url}) no-repeat center`,
                                                                            // backgroundRepeat: "no-repeat",
                                                                            // backgroundSize: "cover",
                                                                        }}>
                                                                        <div className="chooseImg">选择图片</div>
                                                                    </div> :
                                                                    <div className="uploadcover">
                                                                        <div className="chooseImg">选择图片</div>
                                                                    </div>
                                                            }
                                                        </Upload>
                                                        <div
                                                            style={{
                                                                color: "#c1c1c1",
                                                                height: "20px",
                                                                width: "125px",
                                                                fontSize: "12px", position: "relative"
                                                            }}>
                                                            <p>
                                                                {
                                                                    extramsg?.basicField?.avatar?.need ?
                                                                        <span style={{ color: "red" }}>*</span> : null
                                                                }(建议:一寸蓝底证件照)
                                                            </p>
                                                        </div>
                                                    </div>
                                                </Form.Item>
                                            break;
                                        case 'name':
                                            showCont = extramsg?.basicField?.name?.collect &&
                                                <Col span={getFormColSpan(extramsg)}>
                                                    <Form.Item
                                                        label={"姓名"}
                                                        name="name"
                                                        rules={[{ required: true, message: '姓名不能为空!' }]}
                                                    >
                                                        <LgInput
                                                            maxLength={25}
                                                            placeholder="请输入姓名"
                                                            autoComplete='off'
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            break;
                                        case 'gender':
                                            showCont = extramsg?.basicField?.gender?.collect &&
                                                <Col span={getFormColSpan(extramsg)}>
                                                    <Form.Item
                                                        label="性别"
                                                        name={"gender"}
                                                        initialValue={0}
                                                        rules={[{ required: true, message: '请选择性别!' }]}
                                                    >
                                                        <LgRadio.Group>
                                                            <LgRadio value={0}>男</LgRadio>
                                                            <LgRadio value={1}>女</LgRadio>
                                                        </LgRadio.Group>
                                                    </Form.Item>
                                                </Col>
                                            break;
                                        case 'idCard':
                                            showCont = extramsg?.basicField?.idCard?.collect &&
                                                <Col span={getFormColSpan(extramsg)}>
                                                    <Form.Item
                                                        label="身份证号"
                                                        name="idCard"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: '身份证号不能为空!'
                                                            },
                                                            ({ getFieldValue }) => ({
                                                                validator(_, value) {
                                                                    if (!value || !CheckIdCard(value)) {
                                                                        return Promise.resolve();
                                                                    } else if (value && CheckIdCard(value)) {
                                                                        return Promise.reject(new Error(CheckIdCard(value)));
                                                                    }
                                                                    return Promise.reject(new Error('身份证格式有误'));
                                                                },
                                                            }),
                                                        ]}
                                                        getValueFromEvent={
                                                            (event) => {
                                                                return replyCN(event)
                                                            }
                                                        }
                                                    >
                                                        <LgInput
                                                            placeholder="请输入身份证号"
                                                            autoComplete='off'
                                                            maxLength={18}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            break;
                                        case 'phone':
                                            showCont = extramsg?.basicField?.phone?.collect &&
                                                <Col span={getFormColSpan(extramsg)}>
                                                    <Form.Item
                                                        label="联系方式"
                                                        name="phone"
                                                        rules={[{
                                                            required: extramsg?.basicField?.phone?.need,
                                                            message: '联系方式不能为空!'
                                                        },
                                                        ({ getFieldValue }) => ({
                                                            validator(_, value) {
                                                                if (!value || CheckPhone(value)) {
                                                                    return Promise.resolve();
                                                                }
                                                                return Promise.reject(new Error('联系方式格式有误'));
                                                            },
                                                        }),
                                                        ]}
                                                        getValueFromEvent={
                                                            (event) => {
                                                                return replyNum(event)
                                                            }
                                                        }
                                                    >
                                                        <LgInput
                                                            placeholder="请输入联系方式"
                                                            type={'tel'}
                                                            maxLength={11}
                                                            autoComplete='off'
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            break;
                                        case 'email':
                                            showCont = extramsg?.basicField?.email?.collect &&
                                                <Col span={getFormColSpan(extramsg)}>
                                                    <Form.Item
                                                        label="电子邮箱"
                                                        name="email"
                                                        rules={[
                                                            {
                                                                required: extramsg?.basicField?.email?.need, message: '电子邮箱不能为空!'
                                                            },
                                                            ({ getFieldValue }) => ({
                                                                validator(_, value) {
                                                                    if (!value || CheckEmail(value)) {
                                                                        return Promise.resolve();
                                                                    }
                                                                    return Promise.reject(new Error('电子邮箱格式有误'));
                                                                },
                                                            }),
                                                        ]}
                                                    >
                                                        <LgInput
                                                            maxLength={32}
                                                            placeholder="请输入电子邮箱"
                                                            // type={'email'}
                                                            autoComplete='off'
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            break;
                                        case 'enrollMajor':
                                            showCont = extramsg?.basicField?.enrollMajor?.collect &&
                                                <Col span={getFormColSpan(extramsg)}>
                                                    <Form.Item
                                                        label="报名专业"
                                                        name="enrollMajor"
                                                        initialValue={null}
                                                        rules={[
                                                            {
                                                                required: extramsg?.basicField?.enrollMajor?.need, message: '报名专业不能为空!'
                                                            }
                                                        ]}
                                                    >
                                                        <Select
                                                            options={extramsg?.basicField?.enrollMajor?.options?.map((item: any, index: number) => {
                                                                return {
                                                                    label: item.name || item.label || '',
                                                                    value: item.value
                                                                }
                                                            })}
                                                            placeholder="请选择报名专业"
                                                            onChange={(_, curOption: any) => {
                                                                form.setFieldValue('enrollMajor', curOption.value);
                                                            }}
                                                            className={'enrollMajor CommonSelect'}
                                                            style={{ width: 240 }}
                                                            getPopupContainer={(node) => node.parentNode}
                                                        />
                                                        {/* <LgSelect
                                                            datalist={extramsg?.basicField?.enrollMajor?.options?.map((item: any, index: number) => {
                                                                return {
                                                                    text: item.name || item.label || '',
                                                                    value: item.value
                                                                }
                                                            })}
                                                            placeholder="请选择报名专业"
                                                            SelectOption={(value) => {
                                                                setenrollMajor(value.value);
                                                                form.setFieldValue('enrollMajor1', value.text);
                                                                form.validateFields(['enrollMajor1']);
                                                            }}
                                                            value={extramsg?.basicField?.enrollMajor?.options?.find(ele => ele.value === form.getFieldValue('enrollMajor'))?.name}
                                                            size='normal'
                                                        /> */}
                                                    </Form.Item>
                                                </Col>
                                            break;
                                        case 'trainingStage':
                                            showCont = extramsg?.basicField?.trainingStage?.collect &&
                                                <Col span={getFormColSpan(extramsg)}>
                                                    <Form.Item
                                                        label="培养层次"
                                                        name="trainingStage"
                                                        initialValue={null}
                                                        rules={[
                                                            {
                                                                required: extramsg?.basicField?.trainingStage?.need, message: '培养层次不能为空!'
                                                            }
                                                        ]}
                                                    >
                                                        <Select
                                                            options={extramsg?.basicField?.trainingStage?.options?.map((item: any, index: number) => {
                                                                return {
                                                                    ...item,
                                                                    label: item.name || item.label || '',
                                                                    value: item.value || '',
                                                                }
                                                            })}
                                                            // value={form.getFieldValue('trainingStage') === '' ? undefined : form.getFieldValue('trainingStage')}
                                                            placeholder="请选择培养层次"
                                                            onChange={(_, curOption: any) => {
                                                                form.setFieldValue('trainingStage', curOption.value);
                                                            }}
                                                            className={'trainingStage CommonSelect'}
                                                            style={{ width: 240 }}
                                                            getPopupContainer={(node) => node.parentNode}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            break;
                                        case 'firstVolunteer':
                                            let firstVolunteerDisabled: boolean = false;
                                            let firstVolunteerOptions: any[] = extramsg?.basicField?.firstVolunteer?.options;
                                            if (extramsg?.basicField?.trainingStage?.collect) {
                                                if (!form.getFieldValue('trainingStage')) {
                                                    firstVolunteerDisabled = true;
                                                } else {
                                                    const temp = majorList?.filter((item: any) => item?.trainingStageId?.toString() === form.getFieldValue('trainingStage')?.toString());
                                                    firstVolunteerOptions = firstVolunteerOptions?.filter((item: any) => temp.some(major => item.value === major.majorCode));
                                                    if (firstVolunteerOptions.findIndex((item: any) => item.value === form.getFieldValue('firstVolunteer')) === -1) {
                                                        form.setFieldsValue({
                                                            firstVolunteer: undefined, // 清空 第一志愿
                                                        });
                                                    }
                                                }
                                            }
                                            showCont = extramsg?.basicField?.firstVolunteer?.collect &&
                                                <Col span={getFormColSpan(extramsg)}>
                                                    <Form.Item
                                                        label="第一志愿"
                                                        name="firstVolunteer"
                                                        initialValue={null}
                                                        rules={[
                                                            {
                                                                required: extramsg?.basicField?.firstVolunteer?.need, message: '第一志愿不能为空!'
                                                            }
                                                        ]}
                                                    >
                                                        <Select
                                                            disabled={firstVolunteerDisabled}
                                                            options={firstVolunteerOptions?.map((item: any, index: number) => {
                                                                return {
                                                                    ...item,
                                                                    label: item.name || item.label || '',
                                                                    value: item.value || '',
                                                                }
                                                            })}
                                                            // value={form.getFieldValue('firstVolunteer') === '' ? undefined : form.getFieldValue('firstVolunteer')}
                                                            placeholder="请选择第一志愿"
                                                            onChange={(_, curOption: any) => {
                                                                form.setFieldValue('firstVolunteer', curOption.value);
                                                            }}
                                                            className={'firstVolunteer CommonSelect'}
                                                            style={{ width: 240 }}
                                                            getPopupContainer={(node) => node.parentNode}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            break;
                                        case 'secondVolunteer':
                                            let secondVolunteerDisabled: boolean = false;
                                            let secondVolunteerOptions: any[] = extramsg?.basicField?.secondVolunteer?.options;
                                            if (extramsg?.basicField?.trainingStage?.collect) {
                                                if (!form.getFieldValue('trainingStage')) {
                                                    secondVolunteerDisabled = true;
                                                } else {
                                                    const temp = majorList?.filter((item: any) => item?.trainingStageId?.toString() === form.getFieldValue('trainingStage')?.toString());
                                                    secondVolunteerOptions = secondVolunteerOptions?.filter((item: any) => temp.some(major => item.value === major.majorCode));

                                                    if (secondVolunteerOptions.findIndex((item: any) => item.value === form.getFieldValue('secondVolunteer')) === -1) {
                                                        form.setFieldsValue({
                                                            secondVolunteer: undefined, // 清空 第一志愿
                                                        });
                                                    }
                                                }
                                            }

                                            showCont = extramsg?.basicField?.secondVolunteer?.collect &&
                                                <Col span={getFormColSpan(extramsg)}>
                                                    <Form.Item
                                                        label="第二志愿"
                                                        name="secondVolunteer"
                                                        initialValue={null}
                                                        rules={[
                                                            {
                                                                required: extramsg?.basicField?.secondVolunteer?.need, message: '第二志愿不能为空!'
                                                            }
                                                        ]}
                                                    >
                                                        <Select
                                                            disabled={secondVolunteerDisabled}
                                                            options={secondVolunteerOptions?.map((item: any, index: number) => {
                                                                return {
                                                                    ...item,
                                                                    label: item.name || item.label || '',
                                                                    value: item.value || '',
                                                                }
                                                            })}
                                                            placeholder="请选择第二志愿"
                                                            onChange={(_, curOption: any) => {
                                                                form.setFieldValue('secondVolunteer', curOption.value);
                                                            }}
                                                            className={'secondVolunteer CommonSelect'}
                                                            style={{ width: 240 }}
                                                            getPopupContainer={(node) => node.parentNode}
                                                            allowClear
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            break;
                                        case 'thirdVolunteer':
                                            let thirdVolunteerDisabled: boolean = false;
                                            let thirdVolunteerOptions: any[] = extramsg?.basicField?.thirdVolunteer?.options;
                                            if (extramsg?.basicField?.trainingStage?.collect) {
                                                if (!form.getFieldValue('trainingStage')) {
                                                    thirdVolunteerDisabled = true;
                                                } else {
                                                    const temp = majorList?.filter((item: any) => item?.trainingStageId?.toString() === form.getFieldValue('trainingStage')?.toString());
                                                    thirdVolunteerOptions = thirdVolunteerOptions?.filter((item: any) => temp.some(major => item.value === major.majorCode));

                                                    if (thirdVolunteerOptions.findIndex((item: any) => item.value === form.getFieldValue('thirdVolunteer')) === -1) {
                                                        form.setFieldsValue({
                                                            thirdVolunteer: undefined, // 清空 第一志愿
                                                        });
                                                    }
                                                }
                                            }

                                            showCont = extramsg?.basicField?.thirdVolunteer?.collect &&
                                                <Col span={getFormColSpan(extramsg)}>
                                                    <Form.Item
                                                        label="第三志愿"
                                                        name="thirdVolunteer"
                                                        initialValue={null}
                                                        rules={[
                                                            {
                                                                required: extramsg?.basicField?.thirdVolunteer?.need, message: '第三志愿不能为空!'
                                                            }
                                                        ]}
                                                    >
                                                        <Select
                                                            disabled={thirdVolunteerDisabled}
                                                            options={thirdVolunteerOptions?.map((item: any, index: number) => {
                                                                return {
                                                                    ...item,
                                                                    label: item.name || item.label || '',
                                                                    value: item.value || '',
                                                                }
                                                            })}
                                                            placeholder="请选择第三志愿"
                                                            onChange={(_, curOption: any) => {
                                                                form.setFieldValue('thirdVolunteer', curOption.value);
                                                            }}
                                                            className={'thirdVolunteer CommonSelect'}
                                                            style={{ width: 240 }}
                                                            getPopupContainer={(node) => node.parentNode}
                                                            allowClear
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            break;
                                        case 'allowAdjust':
                                            showCont = extramsg?.basicField?.allowAdjust?.collect &&
                                                <Col span={getFormColSpan(extramsg)}>
                                                    <Form.Item
                                                        label="是否允许调剂"
                                                        name={"allowAdjust"}
                                                        rules={[{
                                                            required: extramsg?.basicField?.allowAdjust?.need,
                                                            message: '请选择是否允许调剂!'
                                                        }]}
                                                        initialValue={1}
                                                    >
                                                        <LgRadio.Group>
                                                            <LgRadio value={1}>是</LgRadio>
                                                            <LgRadio value={0}>否</LgRadio>
                                                        </LgRadio.Group>
                                                    </Form.Item>
                                                </Col>
                                            break;
                                        case 'source':
                                            showCont = extramsg?.basicField?.source?.collect &&
                                                <Col span={getFormColSpan(extramsg)}>
                                                    <Form.Item
                                                        label="生源地"
                                                        name="source"
                                                        rules={[
                                                            {
                                                                required: extramsg?.basicField?.source?.need,
                                                                message: '生源地不能为空!'
                                                            },
                                                            ({ getFieldValue }) => ({
                                                                validator(_, value) {
                                                                    if (value?.split('~')?.[0].length < 4 && extramsg?.basicField?.source?.need) {
                                                                        return Promise.reject(new Error(`生源地地区需要选择完！`));
                                                                    }
                                                                    return Promise.resolve();
                                                                }
                                                            })
                                                        ]}
                                                    >
                                                        <SourceAddre
                                                            required={extramsg?.basicField?.source?.need}
                                                            onChange={(value: string) => {
                                                                form.validateFields(['source'])
                                                            }}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            break;
                                        case 'talentedStudent':
                                            showCont = extramsg?.basicField?.talentedStudent?.collect &&
                                                <Col span={getFormColSpan(extramsg)}>
                                                    <Form.Item
                                                        label="特长生"
                                                        name="talentedStudent"
                                                        initialValue={'否'}
                                                        rules={[
                                                            {
                                                                required: extramsg?.basicField?.talentedStudent?.need, message: '特长生不能为空!'
                                                            }
                                                        ]}
                                                    >
                                                        <LgRadio.Group>
                                                            <LgRadio value={'是'}>是</LgRadio>
                                                            <LgRadio value={'否'}>否</LgRadio>
                                                        </LgRadio.Group>
                                                    </Form.Item>
                                                </Col>
                                            break;
                                        case 'languageScore':
                                            showCont = extramsg?.basicField?.languageScore?.collect &&
                                                <Col span={getFormColSpan(extramsg)}><NumericInput
                                                    form={form}
                                                    extramsg={extramsg}
                                                    label="语文分数"
                                                    name="languageScore"
                                                    max={150}
                                                /></Col>
                                            break;
                                        case 'mathScore':
                                            showCont = extramsg?.basicField?.mathScore?.collect &&
                                                <Col span={getFormColSpan(extramsg)}><NumericInput
                                                    form={form}
                                                    extramsg={extramsg}
                                                    label="数学分数"
                                                    name="mathScore"
                                                    max={150}
                                                /></Col>
                                            break;
                                        case 'englishScore':
                                            showCont = extramsg?.basicField?.englishScore?.collect &&
                                                <Col span={getFormColSpan(extramsg)}><NumericInput
                                                    form={form}
                                                    extramsg={extramsg}
                                                    label="英语分数"
                                                    name="englishScore"
                                                    max={150}
                                                /></Col>
                                            break;
                                        case 'physicsScore':
                                            showCont = extramsg?.basicField?.physicsScore?.collect &&
                                                <Col span={getFormColSpan(extramsg)}><NumericInput
                                                    form={form}
                                                    extramsg={extramsg}
                                                    label="物理分数"
                                                    name="physicsScore"
                                                    max={100}
                                                /></Col>
                                            break;
                                        case 'chemistryScore':
                                            showCont = extramsg?.basicField?.chemistryScore?.collect &&
                                                <Col span={getFormColSpan(extramsg)}><NumericInput
                                                    form={form}
                                                    extramsg={extramsg}
                                                    label="化学分数"
                                                    name="chemistryScore"
                                                    max={100}
                                                /></Col>
                                            break;
                                        case 'biologyScore':
                                            showCont = extramsg?.basicField?.biologyScore?.collect &&
                                                <Col span={getFormColSpan(extramsg)}><NumericInput
                                                    form={form}
                                                    extramsg={extramsg}
                                                    label="生物分数"
                                                    name="biologyScore"
                                                    max={100}
                                                /></Col>
                                            break;
                                        case 'politicScore':
                                            showCont = extramsg?.basicField?.politicScore?.collect &&
                                                <Col span={getFormColSpan(extramsg)}><NumericInput
                                                    form={form}
                                                    extramsg={extramsg}
                                                    label="政治分数"
                                                    name="politicScore"
                                                    max={100}
                                                /></Col>
                                            break;
                                        case 'historyScore':
                                            showCont = extramsg?.basicField?.historyScore?.collect &&
                                                <Col span={getFormColSpan(extramsg)}><NumericInput
                                                    form={form}
                                                    extramsg={extramsg}
                                                    label="历史分数"
                                                    name="historyScore"
                                                    max={100}
                                                /></Col>
                                            break;
                                        case 'geographyScore':
                                            showCont = extramsg?.basicField?.geographyScore?.collect &&
                                                <Col span={getFormColSpan(extramsg)}><NumericInput
                                                    form={form}
                                                    extramsg={extramsg}
                                                    label="地理分数"
                                                    name="geographyScore"
                                                    max={100}
                                                /></Col>
                                            break;
                                        case 'sportScore':
                                            showCont = extramsg?.basicField?.sportScore?.collect &&
                                                <Col span={getFormColSpan(extramsg)}><NumericInput
                                                    form={form}
                                                    extramsg={extramsg}
                                                    label="体育分数"
                                                    name="sportScore"
                                                    max={100}
                                                /></Col>
                                            break;
                                        // 鮀滨
                                        case 'returnPremium':
                                            showCont = extramsg?.basicField?.returnPremium?.collect &&
                                                <Col span={getFormColSpan(extramsg)}>
                                                    <Form.Item
                                                        label="是否退费"
                                                        name={"returnPremium"}
                                                        initialValue={0}
                                                        rules={[{ required: extramsg?.basicField?.returnPremium?.need, message: '是否退费不能为空!' }]}
                                                    >
                                                        <LgRadio.Group>
                                                            <LgRadio value={1}>是</LgRadio>
                                                            <LgRadio value={0}>否</LgRadio>
                                                        </LgRadio.Group>
                                                    </Form.Item>
                                                </Col>
                                            break;
                                        case 'pay':
                                            showCont = extramsg?.basicField?.pay?.collect &&
                                                <Col span={getFormColSpan(extramsg)}>
                                                    <Form.Item
                                                        label="是否缴费"
                                                        name={"pay"}
                                                        initialValue={1}
                                                        rules={[{ required: extramsg?.basicField?.pay?.need, message: '是否缴费不能为空!' }]}
                                                    >

                                                        <LgRadio.Group>
                                                            <LgRadio value={1}>是</LgRadio>
                                                            <LgRadio value={0}>否</LgRadio>
                                                        </LgRadio.Group>
                                                    </Form.Item>
                                                </Col>
                                            break;
                                        case 'freeTuition':
                                            showCont = extramsg?.basicField?.freeTuition?.collect &&
                                                <Col span={getFormColSpan(extramsg)}>
                                                    <Form.Item
                                                        label="是否免学费"
                                                        name={"freeTuition"}
                                                        // initialValue={0}
                                                        rules={[{ required: extramsg?.basicField?.freeTuition?.need, message: '是否免学费不能为空!' }]}
                                                    >
                                                        <LgRadio.Group>
                                                            <LgRadio value={1}>是</LgRadio>
                                                            <LgRadio value={0}>否</LgRadio>
                                                        </LgRadio.Group>
                                                    </Form.Item>
                                                </Col>
                                            break;
                                        case 'putUp':
                                            showCont = extramsg?.basicField?.putUp?.collect &&
                                                <Col span={getFormColSpan(extramsg)}>
                                                    <Form.Item
                                                        label="是否住宿"
                                                        name={"putUp"}
                                                        // initialValue={0}
                                                        rules={[{ required: extramsg?.basicField?.putUp?.need, message: '是否住宿不能为空!' }]}
                                                    >
                                                        <LgRadio.Group>
                                                            <LgRadio value={1}>是</LgRadio>
                                                            <LgRadio value={0}>否</LgRadio>
                                                        </LgRadio.Group>
                                                    </Form.Item>
                                                </Col>
                                            break;
                                        case 'enroll32Subsection':
                                            showCont = extramsg?.basicField?.enroll32Subsection?.collect &&
                                                <Col span={getFormColSpan(extramsg)}>
                                                    <Form.Item
                                                        label="是否报读三二分段"
                                                        name={"enroll32Subsection"}
                                                        // initialValue={0}
                                                        rules={[{ required: extramsg?.basicField?.enroll32Subsection?.need, message: '是否报读三二分段不能为空!' }]}
                                                    >
                                                        <LgRadio.Group>
                                                            <LgRadio value={1}>是</LgRadio>
                                                            <LgRadio value={0}>否</LgRadio>
                                                        </LgRadio.Group>
                                                    </Form.Item>
                                                </Col>
                                            break;
                                        case 'registrationNumber':
                                            showCont = extramsg?.basicField?.registrationNumber?.collect &&
                                                <Col span={getFormColSpan(extramsg)}>
                                                    <Form.Item
                                                        label="中考报名号"
                                                        name="registrationNumber"
                                                        rules={[{
                                                            required: extramsg?.basicField?.registrationNumber?.need, message: '中考报名号不能为空!'
                                                        }]}
                                                        getValueFromEvent={(e: any) => {
                                                            const { value } = e.target;
                                                            const tempArr = value.split(".");
                                                            if (tempArr[1]?.length) {
                                                                return `${tempArr[0]}.${tempArr[1].slice(0, 1)}`.replace(
                                                                    // /[^\d{1,}\.\d{1,}|\d{1,}]/g,
                                                                    /[^\d.]|(\.(?=.*\.))/g,
                                                                    ""
                                                                );
                                                            } else {
                                                                // return value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g, "");
                                                                return value.replace(/[^\d.]|(\.(?=.*\.))/g, "")
                                                            }
                                                        }}
                                                    >
                                                        <LgInput
                                                            maxLength={20}
                                                            placeholder={'请输入中考报名号'}
                                                            autoComplete='off'
                                                            className="selfinput"
                                                            onKeyPress={(event) => keyPureMath(event, ['+', 'e', 'E', '-', '.'])}
                                                        // onPressEnter={(event) => keyPureMath(event, ['+', 'e', 'E', '-', '.'])}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            break;
                                        case 'parentPhone':
                                            showCont = extramsg?.basicField?.parentPhone?.collect &&
                                                <Col span={getFormColSpan(extramsg)}>
                                                    <Form.Item
                                                        label="家长手机号"
                                                        name="parentPhone"
                                                        rules={[{
                                                            required: extramsg?.basicField?.parentPhone?.need, message: '家长手机号不能为空!'
                                                        }, ({ getFieldValue }) => ({
                                                            validator(_, value) {
                                                                if (!value || CheckPhone(value)) {
                                                                    return Promise.resolve();
                                                                }
                                                                return Promise.reject(
                                                                    new Error('手机号码格式有误')
                                                                );
                                                            }
                                                        })]}
                                                    >
                                                        <LgInput maxLength={11} placeholder={'请输入家长手机号'} autoComplete='off' className="selfinput" />
                                                    </Form.Item>
                                                </Col>
                                            break;
                                        case 'juniorScore':
                                            showCont = extramsg?.basicField?.juniorScore?.collect &&
                                                <Col span={getFormColSpan(extramsg)}>
                                                    <Form.Item
                                                        label="中考成绩"
                                                        name="juniorScore"
                                                        rules={[{
                                                            required: extramsg?.basicField?.juniorScore?.need, message: '中考成绩不能为空!'
                                                        },
                                                        ({ getFieldValue }) => ({
                                                            validator(_, value) {
                                                                if (value && Number(value) < 0) {
                                                                    return Promise.reject(new Error('输入值要大于0'));
                                                                }
                                                                return Promise.resolve();
                                                            },
                                                        }),]}
                                                        getValueFromEvent={(e: any) => {
                                                            const { value } = e.target;
                                                            const tempArr = value.split(".");
                                                            if (tempArr[1]?.length) {
                                                                return `${tempArr[0]}.${tempArr[1].slice(0, 1)}`.replace(
                                                                    // /[^\d{1,}\.\d{1,}|\d{1,}]/g,
                                                                    /[^\d.]|(\.(?=.*\.))/g,
                                                                    ""
                                                                );
                                                            } else {
                                                                // return value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g, "");
                                                                return value.replace(/[^\d.]|(\.(?=.*\.))/g, "")
                                                            }
                                                        }}
                                                    >
                                                        <LgInput
                                                            placeholder={'请输入中考成绩'}
                                                            autoComplete='off'
                                                            className="selfinput"
                                                            maxLength={5}
                                                        // onKeyPress={(event) => handleKeyPress(event)}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            break;
                                        case 'graduationSchool':
                                            showCont = extramsg?.basicField?.graduationSchool?.collect &&
                                                <Col span={getFormColSpan(extramsg)}>

                                                    <Form.Item
                                                        label="毕业学校"
                                                        name="graduationSchool"
                                                        rules={[{
                                                            required: extramsg?.basicField?.graduationSchool?.need, message: '毕业学校不能为空!'
                                                        }]}
                                                    >
                                                        <LgInput maxLength={32} placeholder={'请输入毕业学校'} autoComplete='off' className="selfinput" />
                                                    </Form.Item>
                                                </Col>
                                            break;
                                        case 'majorName':
                                            showCont = extramsg?.basicField?.majorName?.collect &&
                                                <Col span={getFormColSpan(extramsg)}>
                                                    <Form.Item
                                                        label="专业名称"
                                                        name="majorName"
                                                        initialValue={null}
                                                        rules={[
                                                            {
                                                                required: extramsg?.basicField?.majorName?.need, message: '专业名称不能为空!'
                                                            }
                                                        ]}
                                                    >
                                                        <Select
                                                            options={extramsg?.basicField?.majorName?.options?.map((item: any, index: number) => {
                                                                return {
                                                                    ...item,
                                                                    label: item.name || '',
                                                                    value: item.value || '',
                                                                }
                                                            })}
                                                            placeholder="请选择专业名称"
                                                            onChange={(_, curOption: any) => {
                                                                const list: any = majorList?.find?.(ele => ele.proCode == curOption.value) || {};
                                                                form.setFieldsValue({
                                                                    majorName: curOption.value,
                                                                    proCode: curOption.value,
                                                                    studyPlace: list?.campusId?.toString() || '',
                                                                });
                                                                forceUpdate({})
                                                            }}
                                                            className={'majorName CommonSelect'}
                                                            style={{ width: 240 }}
                                                            getPopupContainer={(node) => node.parentNode}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            break;
                                        case 'proCode':
                                            showCont = extramsg?.basicField?.proCode?.collect &&
                                                <Col span={getFormColSpan(extramsg)}>
                                                    <Form.Item
                                                        label="专业代码"
                                                        name="proCode"
                                                        initialValue={null}
                                                        rules={[
                                                            {
                                                                required: extramsg?.basicField?.proCode?.need, message: '专业代码不能为空!'
                                                            }
                                                        ]}
                                                    >
                                                        <Select
                                                            options={extramsg?.basicField?.majorName?.options?.map((item: any, index: number) => {
                                                                return {
                                                                    ...item,
                                                                    label: item.value || '',
                                                                    value: item.value || '',
                                                                }
                                                            })}
                                                            placeholder="请选择专业代码"
                                                            onChange={(_, curOption: any) => {
                                                                const list: any = majorList?.find?.(ele => ele.proCode == curOption.value) || {};
                                                                form.setFieldsValue({
                                                                    majorName: curOption.value,
                                                                    proCode: curOption.value,
                                                                    studyPlace: list?.campusId?.toString() || '',
                                                                });
                                                                forceUpdate({})
                                                            }}
                                                            className={'proCode CommonSelect'}
                                                            style={{ width: 240 }}
                                                            getPopupContainer={(node) => node.parentNode}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            break;
                                        case 'studyPlace':
                                            // 使用 Set 进行去重

                                            const uniqueValues = extramsg?.basicField?.studyPlace?.options?.reduce((acc, obj) => {
                                                if (!acc.find(item => item.value === obj.value)) {
                                                    acc.push(obj);
                                                }
                                                return acc;
                                            }, []);

                                            showCont = extramsg?.basicField?.studyPlace?.collect &&
                                                <Col span={getFormColSpan(extramsg)}>
                                                    <Form.Item
                                                        label="就读地点"
                                                        name="studyPlace"
                                                        rules={[{
                                                            required: extramsg?.basicField?.studyPlace?.need, message: '就读地点不能为空!'
                                                        }]}
                                                    >
                                                        <Select
                                                            className="CommonSelect teminput"
                                                            placeholder={'请选择就读地点'}
                                                            disabled={true}
                                                            style={{ width: 240 }}
                                                        >
                                                            {
                                                                uniqueValues?.map(
                                                                    (item: any, index: number) => {
                                                                        return (
                                                                            <Select.Option
                                                                                label={item.name || ''}
                                                                                value={item?.value?.toString()}
                                                                            >
                                                                                {item.name || ''}
                                                                            </Select.Option>
                                                                        );
                                                                    }
                                                                )
                                                            }
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                            break;
                                                        
                                        case 'school1':
                                            showCont = extramsg?.basicField?.school1?.collect &&
                                                <Col span={getFormColSpan(extramsg)}>
                                                    <Form.Item
                                                        label="毕业时间"
                                                        name="school1"
                                                        rules={[{
                                                            required: extramsg?.basicField?.school1?.need, message: '毕业时间不能为空!'
                                                        }]}
                                                    >
                                                        <LgDatePicker value={null} placeholder="请选择毕业时间" style={{ height: 32 }} />
                                                    </Form.Item>
                                                </Col>
                                            break;
                                        
                                        //南溪
                                        case 'graduationSchoolName':
                                            showCont = extramsg?.basicField?.graduationSchoolName?.collect &&
                                                <Col span={getFormColSpan(extramsg)}>

                                                    <Form.Item
                                                        label="毕业学校"
                                                        name="graduationSchoolName"
                                                        rules={[{
                                                            required: extramsg?.basicField?.graduationSchoolName?.need, message: '毕业学校不能为空!'
                                                        }]}
                                                    >
                                                        <LgInput maxLength={32} placeholder={'请输入毕业学校'} autoComplete='off' className="selfinput" />
                                                    </Form.Item>
                                                </Col>
                                        break;
                                            default:
                                            break;
                                    }
                                    return showCont;
                                })}
                            </Row>
                        </Form>
                        <Form
                            validateTrigger={['onBlur']}
                            form={extraform}
                            name="extrainfo"
                            labelAlign="right"
                            // labelCol={{ span: 7 }}
                            // wrapperCol={{ span: 17 }}
                            className="intentRegistration_form extramsg"
                        >
                            <Row gutter={24}>
                                {
                                    extramsg?.fields?.map((item, index: number) => {
                                        return <Col span={getColSpan(item)} key={'extra' + index}>
                                            <ExtraItem
                                                ref={(f: extraRefTs) => {
                                                    extraRef.current['extra' + index] = f;
                                                }}
                                                form={extraform}
                                                editmsg={editmsg}
                                                setfile={(value: any) => setfile(value)}
                                                name={'extra' + index + 1}
                                                item={item}
                                                key={'extra' + index}
                                                lgSelectWidth='240px'
                                            />
                                        </Col>
                                    })
                                }
                            </Row>
                        </Form>
                    </div>
                </div>
                <div className='btn_cls'>
                    <LgButton
                        backgroundType='opacification'
                        gradient
                        radius
                        type='info'
                        size='default'
                        style={{ justifyContent: 'center', marginRight: 10, minWidth: 120 }}
                        onClick={reset}
                    >
                        重置
                    </LgButton>
                    <LgButton
                        backgroundType='opacification'
                        gradient
                        radius
                        type='success'
                        size='default'
                        style={{ justifyContent: 'center', minWidth: 120 }}
                        onClick={postData}
                    >
                        提交
                    </LgButton>
                </div>
            </Spin>
            {qrcodeUrl && <div className="btn" style={{ padding: '20px 0px 0 20px' }}>
                <div style={{ display: 'flex', alignItems: 'center', flexFlow: "column" }}>
                    <img src={qrcodeUrl} width={120} height={120} style={{ marginBottom: 8, color: '#333333' }} />
                    <span>扫码填写</span>
                </div>
            </div>}
        </div>
    )
}

export default IntentRegistration
